export default {
  setLoading: (state, v) => { state.loading = v; },
  setErrors: (state, error) => { state.errors = { ...state.errors, ...error }; },
  setEstoreClass: (state, payload) => {
    // only keep the required properties from the incoming data
    const {
      productClassId = null,
      products = [],
      shippingType = null,
      type = null,
      description = ''
    } = payload?.data || {};
    state.productClass = { productClassId, products, shippingType, type, description };
  },
  setConfiguration: (state,payload)=>{
      state.configuration = payload.data;
  }
};